import React from 'react';
import {useIntl} from 'react-intl';

import FlyoutToggleButton from 'brandComponents/flyouts/FlyoutToggleButton';
import Icon from 'brandComponents/Icon';

import messages from './messages';

const QuickSearchServiceMenuItem = () => {
	const intl = useIntl();

	return (
		<FlyoutToggleButton
			buttonContent={
				<Icon
					name="search"
					title={intl.formatMessage(messages.quickSearchTitle)}
					height={20}
					width={20}
				/>
			}
			flyoutId="quickSearch"
		/>
	);
};

export default QuickSearchServiceMenuItem;
